import { graphqlOfflineMutation } from '../../../../../utils/graphql/graphqlOfflineMutation';
import PaymentMutationGql from '../../PaymentMutationGql.graphql';

export const PaymentMutation = graphqlOfflineMutation(PaymentMutationGql, {
  name: 'savePayment',
  mutationName: 'PaymentMutationGql',
});
